import type { RootEpic } from 'MyTypes';
import { combineEpics } from 'redux-observable';

import * as chat from './chat/epics';
import * as dataExplorer from './data-explorer/epics';
import * as dataExplorerValidation from './data-explorer/validation-epics';
import * as entityHierarchies from './entity-hierarchies/epics';
import * as organization from './organization/epics';
import * as resourceLists from './resource-lists/epics';
import * as resources from './resources/epics';
import * as surveys from './surveys/epics';
import * as triggers from './triggers';

const rootEpic: RootEpic = combineEpics(
    ...Object.values(entityHierarchies),
    ...Object.values(dataExplorer),
    ...Object.values(dataExplorerValidation),
    ...Object.values(triggers),
    ...Object.values(resourceLists),
    ...Object.values(resources),
    ...Object.values(organization),
    ...Object.values(surveys),
    ...Object.values(chat)
);

export default rootEpic;
